import { CommentCompany, CommentDate, CommentName, CommentSubject } from '../style';
import * as S from './style';

function LoadingItem() {
  return (
    <S.Wrapper>
      <CommentCompany />
      <CommentSubject />
      <CommentName />
      <CommentDate />
    </S.Wrapper>
  );
}

export default LoadingItem;
